"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const exception_1 = require("@almservices-cl/exception");
class NetworkOnlyStrategy {
    constructor() {
        this.cacheOnly = false;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async get(_key, getRequest) {
        if (this.cacheOnly) {
            throw new exception_1.NetworkException("Network is not available");
        }
        return getRequest();
    }
    goRegular() {
        this.cacheOnly = false;
    }
    goCacheOnly() {
        this.cacheOnly = true;
    }
}
exports.default = NetworkOnlyStrategy;
//# sourceMappingURL=NetworkOnlyStrategy.js.map